import { render, staticRenderFns } from "./_page-betting-rules-aussie-rules-football.vue?vue&type=template&id=602849d0&lang=pug&"
import script from "./_page-betting-rules-aussie-rules-football.vue?vue&type=script&lang=js&"
export * from "./_page-betting-rules-aussie-rules-football.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports